import { useEffect, useMemo, useState } from "react";
import DefaultInput from "../../../../../../common/components/default_input";

export const EditableCellBloco = (props: {
    value: string,
    idBloco: number,
    onChangeValue: (newValue: string) => void,
    onDoubleClickBloco: () => void,
    onBlocoTitleChange: (newName: string, idBloco: number) => void

}) => {
    const [isEditable, setIsEditable] = useState(false);

    const content = useMemo(() => {
        return (
            <div onDoubleClick={() => {
                setIsEditable(true)
                props.onDoubleClickBloco()

            }}>
                {
                    isEditable ? (
                        <DefaultInput
                            onBlur={() => {
                                setIsEditable(false)
                                props.onBlocoTitleChange(props.value, props.idBloco)

                            }}
                            name='Teste'
                            value={props.value}
                            onChangeValue={props.onChangeValue} />
                    ) : (
                        <div>{props.value}</div>
                    )
                }
            </div>
        );
    }, [
        isEditable,
        props.value,
        props.onBlocoTitleChange,
        props.onDoubleClickBloco,
    ]);
    return <>{content}</>;
}


export const EditableCellUnidade = (props: {
    value: string,
    idUnidade: number,
    idBloco: number,
    onChangeValue: (newValue: string) => void,
    onDoubleClickUnidade: () => void,
    onUnidadeTitleChange: (newName: string, idUnidade: number, idBloco: number) => void
    // Incrementar este valor entra no modo de edição (ex.: opção "Editar" do menu da unidade).
    editSignal?: number

}) => {
    const [isEditable, setIsEditable] = useState(false);
    const [valorTemporario, setValorTemporario] = useState(props.value)

    useEffect(() => {
        setValorTemporario(props.value)
    }, [props.value])

    const { editSignal, onDoubleClickUnidade } = props
    useEffect(() => {
        if (editSignal) {
            setIsEditable(true)
            onDoubleClickUnidade()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [editSignal])

    const content = useMemo(() => {

        return (
            <div onDoubleClick={() => {
                setIsEditable(true)
                props.onDoubleClickUnidade()

            }}>
                {
                    isEditable ? (
                        <DefaultInput
                            autoFocus
                            onBlur={() => {
                                setIsEditable(false)
                                props.onChangeValue(valorTemporario)
                                props.onUnidadeTitleChange(valorTemporario, props.idUnidade, props.idBloco)

                            }}
                            name='Teste'
                            value={valorTemporario}
                            onChangeValue={v => setValorTemporario(v)} />
                    ) : (
                        <div>{valorTemporario}</div>
                    )
                }
            </div>
        );
    }, [
        isEditable,
        valorTemporario,
        props.onChangeValue,
        props.onUnidadeTitleChange,

    ]);
    return <>{content}</>;
}


